import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "../../../../style/custommillingHubdashboard.css";
import "../../../../style/customresponsivefile.css";
import "../../../../style/Cancelorder.css";

import SearchBox from "../../../../Interfaces/SearchBoxProps";
import SortFilter from "../../Designer/SortFilter";
import { CompleteOrderRow } from "./../Interfaces/CompleteOrderRow";
import { apiAxios } from "../../../../utils/apiAxios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../style/Cancelorder.css";
import { ManagerOrderReviewRow } from "../../../../Interfaces/ManagerOrderReviewRow";
import { Row } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import WarrantyCard from "./WarrantyCard";
import { useNavigate } from "react-router-dom";

const CompleteOrder: React.FC = () => {
  const [activeTab, setActiveTab] = useState("status");
  const [orders, setOrders] = useState<CompleteOrderRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedOrder, setSelectedOrder] = useState<CompleteOrderRow | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage] = useState(10);
  const [statusFilter, setStatusFilter] = useState("All")
  const [orderDetails, setOrderDetails] = useState<any>(null);
  const [openDelayIndex, setOpenDelayIndex] = useState<number | null>(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [orderReview, setOrderReview] = useState<ManagerOrderReviewRow[]>([]);
  const [scans, setScans] = useState<ModalScanFile[]>([]);
  const [orderView, setOrderView] = useState<"full" | "design">("full");
  const navigate = useNavigate();
const API_PATH = process.env.REACT_APP_API_PATH_URL || "";
  const EllipsisText = ({ text }: { text: string }) => (
    <span
      title={text}
      style={{
        display: "inline-block",
        maxWidth: "120px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </span>
  );
  // 🔥 API CALL
  interface ModalScanFile {
    path: string;
    name: string;
  }
  const fetchOrders = async (pageNumber = 1, search = "") => {
    try {
      setLoading(true);

      const res = await apiAxios.get("/Central/completed-orders", {
        params: {
          search,
          pageNumber,
          pageSize: perPage
        }
      });
     
      const json = res.data;
     console.log("Completed Orders API Response:", res.data);
      if (json.isSuccess) {

        const apiData = json.dataOne.data;

        const mapped = apiData.map((item: any) => {

          //console.log("Order Type:", item.orderTypeName);

          return {
            orderId: item.orderID ?? "-",
            caseId: item.caseID ?? "-",
            clinicName: item.clinicName ?? "-",
            phone: item.phone ?? "-",
            orderTypeName: item.orderTypeName ?? "-",
            orderDate: item.orderDate
              ? new Date(item.orderDate)
                .toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })
                .replace(",", "")
              : "-",
            millingHub: item.millingHub ?? "-",
            designerName: item.designerName ?? "-",
            deliveryPartner: item.deliveryPartner ?? "-",
            deliveryDate: item.deliveryDate
              ? new Date(item.deliveryDate)
                .toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })
                .replace(",", "")
              : "-",
            amount: item.paidAmount ?? "-",
            payment: item.paymentStatus ?? "-",
            paymentType: item.paymentType ?? "-",
            status: item.status ?? "-"
          };
        });

        setOrders(mapped);
        setTotalRows(json.dataOne.totalRecords);

      } else {
        toast.error("No data found");
      }

    } catch (error) {
      console.error(error);
      toast.error("Failed to load completed orders");
    } finally {
      setLoading(false);
    }
  };

  const chunkArray = (arr: any[], size: number) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };
  const fetchWarranty = async (caseId: number) => {
    try {
      const res = await apiAxios.get(`/DeliveryPartner/GetWarrantyByCase`, {
        params: { caseId }
      });

      if (res.data?.isSuccess) {
        return res.data.data; // multiple warranty cards possible

      }
    } catch {
      toast.error("Failed to fetch warranty");
    }
  };
  const downloadWarrantyPDF = async (row: any) => {

    const warranties = await fetchWarranty(row.caseId);

    if (!warranties || warranties.length === 0) {
      toast.error("No warranty found");
      return;
    }
    const pages = chunkArray(warranties, 3); // 🔥 3 cards per page

    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < pages.length; i++) {

      const container = document.createElement("div");
      container.style.position = "fixed";
      container.style.top = "-9999px";   // 👈 push outside screen
      container.style.left = "-9999px";
      container.style.width = "800px";
      container.style.padding = "20px";
      container.style.background = "#fff";

      document.body.appendChild(container);

      const { createRoot } = await import("react-dom/client");
      const root = createRoot(container);

      // 🔥 Render only current page cards
      root.render(
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {pages[i].map((w: any, index: number) => (
            <WarrantyCard
              key={index}
              data={{
                patientName: w.patientName,
                mobile: w.deliveryContact,
                treatment: w.treatmentType,
                toothNumber: w.toothNumber,
                material: w.material,
                warrantyMonths: w.warrantyPeriodMonths,
                validTill: new Date(w.warrantyEndDate).toLocaleDateString(),
                warrantyNumber: w.warrantyNumber,
                dentistName: w.name
              }}
            />
          ))}
        </div>
      );

      // 🔥 wait for render
      await new Promise(res => setTimeout(res, 2000));

      const canvas = await html2canvas(container, {
        scale: 3,
        useCORS: true
      });

      const imgData = canvas.toDataURL("image/png");

      if (i > 0) pdf.addPage(); // 🔥 next page

      pdf.addImage(imgData, "PNG", 10, 10, 190, 0);

      root.unmount();
      document.body.removeChild(container);
    }

    pdf.save(`Warranty-${row.caseId}.pdf`);


  };
  const formatToValidDate = (dateTime: string | null, baseDate?: string) => {
    if (!dateTime) return null;

    // If already full ISO datetime
    if (dateTime.includes("T")) {
      return new Date(dateTime);
    }

    // If only time (HH:mm:ss)
    if (baseDate) {
      return new Date(`${baseDate.split("T")[0]}T${dateTime}`);
    }

    return null;
  };
  const fetchOrderDetails = async (orderId: string) => {
    try {
      setDetailsLoading(true);
      setActiveTab("status");

      const res = await apiAxios.get(`/Central/complete-order-status`, {
        params: { orderID: orderId }
      });

      if (res.data?.isSuccess && res.data?.data?.length > 0) {

        const apiData = res.data.data[0];

const isDesignService =
  apiData?.isDesignService === true ||
  apiData?.isDesignService === "true";

const timeline = [
  {
    time: formatToValidDate(apiData.createdDate),
    event: "Order Created",
    status: "Completed",
  },

  {
    time: formatToValidDate(
      apiData.paymentTime,
      apiData.createdDate
    ),
    event: (
      <div>
        <div>
          <strong>Payment Successful</strong>
        </div>
        <div className="small text-muted mt-1">
          <div>
            Original Amount : ₹{apiData?.originalAmount ?? "--"}
          </div>
          <div>
            Discount Amount : ₹{apiData?.discountAmount ?? "--"}
          </div>
          <div>
            Coupon : {apiData?.couponPercentage ?? "--"}% Off
          </div>
          <div>
            <strong>
              Paid Amount : ₹{apiData?.paidAmount ?? "--"}
            </strong>
          </div>
        </div>
      </div>
    ),
    status:
      apiData.paymentStatus === "Paid"
        ? "Completed"
        : "Pending",
  },

  {
    time: formatToValidDate(
      apiData.designerActualApprovalTime,
      apiData.createdDate
    ),
    event:
      apiData.designerApprovalStatus !== "Pending"
        ? `Scan Approved by ${apiData.design}`
        : "Scan not approved yet",
    status: apiData.designerApprovalStatus || "Pending",
    reason: apiData.designerDelayReason,
  },

  // ✅ Milling only for Full Service
  ...(!isDesignService
    ? [
        {
          time: formatToValidDate(
            apiData.millingActualApprovalTime,
            apiData.createdDate
          ),
          event:
            apiData.millingApprovalStatus !== "Pending"
              ? `${apiData.milling} accepted order`
              : "Awaiting milling acceptance",
          status:
            apiData.millingApprovalStatus || "Pending",
          reason: apiData.millingDelayReason,
        },
      ]
    : []),

  {
    time: formatToValidDate(apiData.expectedETA),
    event: "Current Status",
    status: apiData.currentStatus || "Completed",
  },
];

        setOrderDetails({
          ...apiData,
          timeline
        });

        setIsOrderModalOpen(true);
      }

    } catch {
      toast.error("Failed to load order details");
    } finally {
      setDetailsLoading(false);
    }
  };
  const fetchOrderReviewByCaseId = async (caseId: number) => {

    try {
      setDetailsLoading(true);

      // const res = await apiAxios.get(`/Central/complete-order-review`, {
      //   params: { caseID: caseId }
      // });

      const res = await apiAxios.get(
        `/Central/complete-order-review?caseID=${caseId}`
      );

      if (res.data?.isSuccess) {

        const reviewData = res.data.data || [];
        setOrderReview(reviewData);

        // ✅ Take dentist scans only once
        const firstItem = reviewData[0];

        let allScans: ModalScanFile[] = [];

        if (firstItem) {
          const names = (firstItem.fileNames || "")
            .split(",")
            .map((n: string) => n.trim())
            .filter(Boolean);

          const paths = (firstItem.filePaths || "")
            .split(",")
            .map((p: string) => p.trim())
            .filter(Boolean);

          allScans = names.map((name: string, i: number) => ({
            name,
            path: paths[i]
          })).filter((x: ModalScanFile) => x.path);
        }

        setScans(allScans);
      }

    } catch {
      toast.error("Failed to load order review");
    } finally {
      setDetailsLoading(false);
    }
  };
 const onViewStl = (scan: ModalScanFile) => {
  if (!scan.path) {
    toast.error("STL not available");
    return;
  }

  navigate("/central/AdminstlpreviewNew", {
    state: {
      stlUrl: `${API_PATH}${scan.path}`,
    },
  });
};
 const constructFileUrl = (filePath: string): string => {
  if (!filePath) return "";

  const cleanPath = filePath.trim();

  // Already a complete URL
  if (
    cleanPath.startsWith("http://") ||
    cleanPath.startsWith("https://")
  ) {
    return cleanPath;
  }

  const baseUrl = (
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    ""
  ).replace(/\/api\/?$/, "")
   .replace(/\/$/, "");

  const cleanFilePath = cleanPath.replace(/^\/+/, "");

  return `${baseUrl}/${cleanFilePath}`;
};
   const downloadFile = async (filePath: string, fileName?: string) => {
     const fullUrl = constructFileUrl(filePath);
 
     try {
       const token = sessionStorage.getItem("token");
 
       const { data, headers } = await apiAxios.get(fullUrl, {
         responseType: "blob", // ✅ critical
         headers: {
           Authorization: token ? `Bearer ${token}` : "",
           AuthorizationData: token || "",
         },
       });
 
       // 📄 Get file type
       //const contentType = headers["content-type"];
 
       // 📄 Try to extract filename from backend
       let finalName = fileName;
       const disposition = headers["content-disposition"];
 
       if (!finalName && disposition) {
         const match = disposition.match(/filename="?(.+?)"?$/);
         if (match) finalName = match[1];
       }
 
       finalName = finalName || "download";
 
       // 📦 Create blob
       //const blob = new Blob([data], { type: contentType });
 
       const contentType =
         typeof headers["content-type"] === "string"
           ? headers["content-type"]
           : undefined;
 
       const blob = new Blob([data], {
         type: contentType,
       });
       const url = window.URL.createObjectURL(blob);
 
       // ⬇️ Trigger download
       const link = document.createElement("a");
       link.href = url;
       link.download = finalName;
       document.body.appendChild(link);
       link.click();
 
       // 🧹 Cleanup
       setTimeout(() => {
         document.body.removeChild(link);
         window.URL.revokeObjectURL(url);
       }, 100);
 
       toast.success(`Downloading ${finalName}`);
       return true;
     } catch (error: any) {
       console.error("❌ Axios download failed:", error);
 
       // 🔁 Fallback (keep this)
       try {
         window.open(fullUrl, "_blank");
         toast.info(
           "Opened in new tab. Right-click → Save As to download."
         );
         return false;
       } catch {
         toast.error("Failed to download file");
         return false;
       }
     }
   };
  // 🔥 PAGE CHANGE
  useEffect(() => {
    fetchOrders(page, searchText);
  }, [page]);

  // 🔥 SEARCH (Debounce)
  useEffect(() => {
    const delay = setTimeout(() => {
      setPage(1);
      fetchOrders(1, searchText);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchText]);
  const displayedOrders = orders.filter(order =>
    orderView === "design"
      ? order.orderTypeName === "Design Service"
      : order.orderTypeName !== "Design Service"
  );

  // 🔥 TABLE COLUMNS
  const columns = [
    {
      name: "OrderID",
      selector: (row: CompleteOrderRow) => row.orderId,
      sortable: true
    },
    {
      name: "Order Type",
      cell: (row: CompleteOrderRow) => (
        <EllipsisText text={row.orderTypeName} />
      )
    },

    {
      name: "Clinic / Phone",
      minWidth: "180px",
      cell: (row: CompleteOrderRow) => (
        <div>
          <div className="fw-semibold">
            <EllipsisText
              text={row.clinicName || ""}

            />
          </div>

          <div className="text-muted">
            {row.phone}
          </div>
        </div>
      )
    },

    {
      name: "Order Date",
      selector: (row: CompleteOrderRow) => row.orderDate,
      minWidth: "170px"
    },

    ...(orderView === "full"
  ? [
      {
        name: "Milling Hub",
        cell: (row: CompleteOrderRow) => (
          <EllipsisText
            text={row.millingHub || ""}
          />
        ),
        sortable: true,
      },
    ]
  : []),
    {
      name: "Payment",
      cell: (row: CompleteOrderRow) => (
        <span className="badge bg-success">
          {row.amount}
        </span>
      )
    },

    {
      name: "Status",
      cell: (row: CompleteOrderRow) => (
        <span className="badge bg-success">
          {row.status}
        </span>
      ),
      minWidth: "170px"
    },

    {
      name: "View",
      cell: (row: CompleteOrderRow) => (
        <button
          className="action-btn edit"
          onClick={() => {
            setSelectedOrder(row);
            fetchOrderDetails(row.orderId);
            fetchOrderReviewByCaseId(row.caseId); // make sure caseId exists
            setShowModal(true);
          }}
        >
          <i className="bi bi-eye"></i>
        </button>

      ),

    },

    ...(orderView === "full"
      ? [
        {
          name: "Warranty",
          cell: (row: CompleteOrderRow) => (
            <button
              className="btn btn-sm btn-primary"
              onClick={() => downloadWarrantyPDF(row)}
            >
              <i className="bi bi-download"></i> PDF
            </button>
          ),
        },
      ]
      : []),

  ];

  return (

    <div className="container-fluid mt-4">


      <h4 className="mb-4">Completed Orders</h4>


      <div className="premium-card mt-4">

        <div className="mb-3 d-flex gap-4">
          <label>
            <input
              type="radio"
              checked={orderView === "full"}
              onChange={() => setOrderView("full")}
            />
            {" "}Full Service
          </label>

          <label>
            <input
              type="radio"
              checked={orderView === "design"}
              onChange={() => setOrderView("design")}
            />
            {" "}Design Service
          </label>
        </div>

        <div className="d-lg-flex d-md-block justify-content-md-between justify-content-lg-between mb-3">

          <SearchBox
            value={searchText}
            onChange={setSearchText}
          />

          <SortFilter />

        </div>

        <DataTable
          columns={columns}
          data={displayedOrders}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={(page) => setPage(page)}
          highlightOnHover
          striped
          responsive
          progressPending={loading}
          fixedHeader
          fixedHeaderScrollHeight="500px"
          className="admin-delivery-table"
        />

      </div>

      {showModal && selectedOrder && (

        <div className="modal fade show d-block modal-bg">

          <div className="modal-dialog modal-lg admin-order-modal-dialog" style={{ maxWidth: "980px" }}>

            <div
              className="modal-content"
              style={{ minHeight: "580px" }}
            >

              <div className="modal-header premium-modal-header" >

                {/* <h5>Order Details</h5> */}
                <h5 className="modal-title"> Order Details: {selectedOrder?.orderId || "--"}</h5>

                <button
                  className="custom-close-btn btn-close "
                  onClick={() => setShowModal(false)}
                >
                  <i className="bi bi-x customcross"></i>
                </button>

              </div>
              <div className="dentist-approval-pending pt-3 d-flex justify-content-end align-items-center">

                <span className="status-badge success"><i className="bi bi-check-circle-fill completed-icon"></i>Completed</span>

              </div>
              <div className="d-flex border-bottom tab-border-bottom-section mx-3 pt-2">
                <button
                  className={activeTab === "status" ? "btn order-status-text btn-link active-tab-section" : " btn"}
                  onClick={() => setActiveTab("status")}
                >
                  Order Status
                </button>

                <button
                  className={activeTab === "details" ? "btn order-status-text btn-link active-tab-section" : "btn order-details-btn-sect"}
                  onClick={() => setActiveTab("details")}
                >
                  Order Details
                </button>


              </div>

              <div className="modal-body premium-modal-body">


                {activeTab === "status" && (
                  <div className="row">

                    {/* LEFT */}
                    <div className="col-md-6 border-end">

                      <ul className="list-unstyled order-status-list delivery-type-section"><li className="time-event-section-delivery-type"><strong className="strongtext-fontweight Delivery-Type-text">Delivery Type</strong><span>{orderDetails?.deliveryType || "--"}</span></li>
                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Payment Status</strong><span>{orderDetails?.paymentStatus || "--"}</span></li>
                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Original ETA</strong><span>
                          {orderDetails?.originalETA
                            ? new Date(orderDetails.originalETA).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                            : "--"}
                        </span></li>

                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Expected ETA</strong> <span>{orderDetails?.expectedETA
                          ? new Date(orderDetails.expectedETA).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                          : "--"}</span></li>

                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Delivery Date</strong><span>{selectedOrder.deliveryDate}</span></li>


                        <li className="time-event-section-delivery-type mt-1">

                        </li>

                      </ul>
                      <div className="accordion mt-3" id="accordionExample">

                        {[
                          { key: "clinic", name: "Clinic" },
                          { key: "designer", name: "Designer" },
                          { key: "milling", name: "Milling" },
                          { key: "delivery", name: "Delivery Partner" }
                        ].map((section) => (

                          <div key={section.key} className="accordion-item border rounded p-2 mt-3">

                            <h2 className="accordion-header">
                              <button
                                className={`accordion-button ${section.key !== "clinic" ? "collapsed" : ""}`}
                                data-bs-toggle="collapse"
                                data-bs-target={`#${section.key}`}
                              >
                                {section.name}
                              </button>
                            </h2>

                            <div
                              id={section.key}
                              className={`accordion-collapse collapse ${section.key === "clinic" ? "show" : ""}`}
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">

                                {/* NAME */}
                                <div className="doctor-name-bottom">
                                  {
                                    section.key === "clinic" ? orderDetails?.clinic || "--" :
                                      section.key === "designer" ? orderDetails?.design || "--" :
                                        section.key === "milling" ? orderDetails?.milling || "--" :
                                          orderDetails?.deliveryPartner || "--"
                                  }
                                </div>

                                {/* MOBILE */}
                                <div className="doctor-name-bottom">
                                  {
                                    section.key === "clinic" ? orderDetails?.clinicMobileNo || "--" :
                                      section.key === "designer" ? orderDetails?.designMobileNo || "--" :
                                        section.key === "milling" ? orderDetails?.millingMobileNo || "--" :
                                          orderDetails?.deliveryPartnerMobileNo || "--"
                                  }
                                </div>

                                {/* ADDRESS */}
                                {section.key !== "designer" && (
                                  <div className="doctor-name-bottom">
                                    {
                                      section.key === "clinic" ? orderDetails?.clinicAddress || "--" :
                                        section.key === "milling" ? orderDetails?.millingAddress || "--" :
                                          orderDetails?.deliveryPartnerAddress || "--"
                                    }
                                  </div>
                                )}

                              </div>
                            </div>

                          </div>
                        ))}

                      </div>


                    </div>

                    {/* RIGHT */}
                    <div className="col-md-6">
                      <ul className="list-unstyled order-status-timeline">

                        <li className="time-event-sectionborder-bottom time-event-section pb-2 mb-2">
                          <strong>Time</strong>
                          <strong>Event</strong>
                          <strong>Status</strong>
                        </li>

                        {(orderDetails?.timeline || []).map((item: any, index: number) => (
                          <li key={index} className="time-event-section">

                            <strong className="strongtext-fontweight Delivery-Type-text">
                              {item.time && !isNaN(new Date(item.time).getTime())
                                ? new Date(item.time).toLocaleTimeString("en-IN", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                })
                                : "--"}
                            </strong>

                            <span
                              style={{ cursor: item.status === "Delayed" ? "pointer" : "default" }}
                              onClick={() => {
                                if (item.status === "Delayed") {
                                  setOpenDelayIndex(openDelayIndex === index ? null : index);
                                }
                              }}
                            >
                              {item.event}
                            </span>

                            <span
                              className={`status-part ${item.status === "Delayed" ? "text-danger fw-bold" : ""
                                }`}
                            >
                              {item.status}
                              {item.status === "Delayed"
                                ? openDelayIndex === index
                                  ? " ▲"
                                  : " ▼"
                                : ""}
                            </span>

                            {item.status === "Delayed" && openDelayIndex === index && (
                              <div className="w-100 ps-2 mt-1 text-muted small">
                                Reason: {item.reason || "--"}
                              </div>
                            )}
                          </li>
                        ))}

                      </ul>

                    </div>

                  </div>
                )}


                {activeTab === "details" && <div>

                  <div className="row p-0">

                    {/* 🔹 LEFT SECTION (TABLE) */}
                    <div className="col-lg-9 col-md-12 col-12">
                      <table className="table table-sm table-borderless table-content-insidethetable">

                        <thead>
                          <tr>
                            <th>Tooth</th>
                            <th>Material</th>
                            <th>Shade</th>
                            <th>Design</th>
                          </tr>
                        </thead>

                        <tbody>
                          {orderReview.map((review, index) => (
                            <tr key={index}>
                              <td>{review.tooth || "--"}</td>
                              <td>{review.material || "--"}</td>
                              <td>{review.shade || "--"}</td>
                              <td className="scrollable-td text-truncate">
                                <div className="d-flex flex-column file-uploaded-designer">
                                  {(review.designerFileNames || "")
                                    .split(",")
                                    .filter(Boolean)
                                    .map((file: string, i: number) => (
                                      <span key={i}>{file}</span>
                                    ))}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>


                      </table>
                    </div>

                    {/* 🔹 RIGHT SECTION (SCANS) */}
                    <div className="col-lg-3 col-md-12 col-12 border-start px-2">

                      <strong className="scans-fontweight500 mb-2 mt-3 d-block">
                        Scans (By Dentist)
                      </strong>

                      {scans.length === 0 ? (
                        <p className="text-muted">No scans available</p>
                      ) : (
                        scans.map((scan, index) => (
                          <div
                            key={index}
                            className="scan-item d-flex justify-content-between align-items-center mt-2 px-2 py-1 border rounded"
                          >
                            <span
                              className="text-truncate"
                              style={{ maxWidth: "120px" }}
                              title={scan.name}
                            >
                              {scan.name}
                            </span>

                            <div className="d-flex gap-2">
                              <i
                                className="bi bi-eye"
                                title="View STL"
                                style={{ cursor: "pointer" }}
                                 onClick={() => onViewStl(scan)}
                              ></i>

                              <i
                                className="bi bi-download text-primary"
                                title="Download STL"
                                style={{ cursor: "pointer" }}
                                onClick={async (e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  await downloadFile(scan.path, scan.name);
                                }}
                              ></i>
                            </div>
                          </div>
                        ))
                      )}

                    </div>

                  </div>
                </div>}


              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default CompleteOrder;